/**
 * @author yan st
 * @date 2022-08-16 08:40
 * @Description:
 */
import {qspost} from '@/plugins/axios'

/*
*   账号登录
* */
export const passLogin = (user_name,password) => qspost('/api/index/login', {user_name,password})

/*
* 验证码登录
* */
export const codeLogin = (phone,code) => qspost('/api/index/smsLogin', {phone,code})

/*
* 微信登录
* */
export const wxLogin = (code) => qspost('/home/Index/wx_login', {code})

/*
* 验证手机号是否存在
* */
export const CheckPhone = (phone) => qspost('/home/Index/CheckPhone', {phone})

/*
*  获取验证码
* */
export const sendCode = (phoneNum) => qspost('/api/index/sendPhoneNumber', {phoneNum})

/*
*  注册
* */
export const register = (
  phone,code,password,repassword
) => qspost('/Home/Index/sms_reg', {
  phone,code,password,repassword
})

/*
* 益书宝协议
* */
export const Getxieyi = () => qspost('/home/Index/Getxieyi', {})

/*
* 找回密码
* */
export const findPass = (
  phone,code,pass,repass
) => qspost('/api/index/findPass', {
  phone,code,pass,repass
})


/*
*  手机号绑定
* */
export const bindPhone = (phone,code,data) => qspost('/home/Index/BdPhone', {phone,code,data})

/*
* 单点登录
* */
export const dandian = (emofUserTokenSafer) => qspost('/api/index/synchronouslogin', {emofUserTokenSafer})





/*
 * 迭代通知列表
 * */
export const getVersionDetail = (mid,id) => qspost('index/Iterative/getInfo', {mid,id})

/*
 * 迭代通知列表
 * */
export const getVersionList = (mid,page,limit) => qspost('index/Iterative/getList', {mid,page,limit})


/*
 * 迭代通知不再提醒
 * */
export const noRemind = (id,type,mid) => qspost('index/Iterative/noRemind', {id,type,mid})

/*
 * 服务列表
 * */
export const getInfo = (type,mid) => qspost('index/Iterative/getInfo', {type,mid})


/*
 * 使用说明
 * type  11 机构端 12 分会端 13 会员端
 * */

export const getHelpList = (type) => qspost('index/help/getInfo', {type})



















